export function replaceDealById(deals, updatedDeal) {
  if (!Array.isArray(deals) || !updatedDeal?.id) return deals;
  const idx = deals.findIndex((d) => d.id === updatedDeal.id);
  if (idx === -1) return deals;
  const next = deals.slice();
  next[idx] = updatedDeal;
  return next;
}

